import React from 'react';

import PropTypes from 'prop-types';
import {
  faCircleCheck,
  faCircleXmark,
} from '@awesome.me/kit-a6e51d954f/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ATTRIBUTES = {
  true: {
    ariaLabel: 'Yes',
    color: 'text-green-500',
    icon: faCircleCheck,
  },
  false: {
    ariaLabel: 'No',
    color: 'text-red-500',
    icon: faCircleXmark,
  },
};

const BooleanCell = ({ value = false }) => (
  <FontAwesomeIcon
    aria-label={ATTRIBUTES[value].ariaLabel}
    className={ATTRIBUTES[value].color}
    icon={ATTRIBUTES[value].icon}
    size="lg"
  />
);

BooleanCell.propTypes = {
  value: PropTypes.bool,
};

export default BooleanCell;
